<template>
    <div v-if="showChatButton" class="fixed z-10 pin-b pin-r mb-lg mr-lg text-right">
        <div
            v-if="showToolTip"
            class="mb-sm py-lg px-xl flex items-center rounded bg-white shadow-floating text-xs text-neutral-darker"
        >
            {{ lang('Hej! Behöver du hjälp?', 'Hello!, Need any help?') }}

            <button
                type="button"
                class="ml-sm hover:text-accent-red"
                @click="showToolTip = false"
            >
                <font-awesome-icon icon="times" />
            </button>
        </div>
        <button
            class="h-4xl w-4xl inline-flex items-center justify-center bg-accent-yellow shadow-floating hover:bg-accent-yellow-darker"
            style="border-radius: 28px; border-bottom-right-radius: 4px;"
            type="button"
            onclick="window.fcWidget.open()"
        >
            <img src="/img/chat-bubble-icon.svg">
        </button>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                showToolTip: false, // temp disabled by Ownits wish
                showChatButton: false,
            };
        },
        mounted() {
            EventBus.$on('freshChatLoaded', () => this.showChatButton = true);
            EventBus.$on('freshChatOpen', () => this.showChatButton = false);
            EventBus.$on('freshChatClosed', () => this.showChatButton = true);
        },
    };
</script>
